import type { ChatMessage, ChatNote, MessageSender } from './chat-message.interface'

export type BubbleVariant = 'user' | 'assistant' | 'system' | 'note' | 'error'

interface GetBubbleVariantOptions {
  type: 'message' | 'note'
  sender?: MessageSender
  hasError?: boolean
}

export const getBubbleVariant = (options: GetBubbleVariantOptions): BubbleVariant => {
  const { type, sender, hasError } = options

  if (hasError) return 'error'
  if (type === 'note') return 'note'
  if (sender === 'system') return 'system'
  if (sender === 'user') return 'user'
  return 'assistant'
}

export const getSenderName = (
  isAssistant: boolean,
  agentName: string,
  participantName?: string
): string => {
  if (isAssistant) return participantName ?? agentName
  return participantName ?? 'Unknown'
}

export const getMessageTypeClass = (isNote: boolean, isAssistant: boolean): string => {
  if (isNote) return 'chat-message-note'
  if (isAssistant) return 'chat-message-agent'
  return 'chat-message-user'
}

export const DEFAULT_AGENT_NAME = 'Agent'

export const getMessageSender = (message: ChatMessage | ChatNote): MessageSender =>
  message.type === 'note' ? 'user' : message.sender

export const isMessageRightAligned = (
  isOwn: boolean,
  isNote: boolean,
  isAssistant: boolean
): boolean => isOwn || isNote || !isAssistant

export const hasMessageError = (message: ChatMessage | ChatNote): boolean =>
  'errorMessage' in message && !!message.errorMessage

export const getBubbleVariantForMessage = (
  message: ChatMessage | ChatNote,
  sender: MessageSender
): BubbleVariant =>
  getBubbleVariant({
    type: message.type,
    sender,
    hasError: hasMessageError(message),
  })
